<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.5 32.1698V15H80V85H30V67.3899" stroke="black" stroke-width="4" stroke-linecap="square"/>
<path d="M10 50L46.5 50" stroke="black" stroke-width="4" stroke-linecap="square"/>
<path d="M40 60L50 50L40 40" stroke="black" stroke-width="4" stroke-linecap="square"/>
</svg>

</template>
